@if (initialized) {
  <section class="header">
    @if (account) {
      <app-account-icon [account]="account" size="48px"></app-account-icon>
    }
    <div class="title">
      <div class="heading-3">{{issue.title}}</div>
      @if (account) {
        <div class="mat-caption">{{account.name}} {{issue.created_at | dateFormat : 'ago'}} ago</div>
      }
    </div>
  </section>
  <section class="body">
    <div class="mat-body">{{issue.description}}</div>
  </section>
  <section class="footer">
    @if (issue.status === 'closed') {
      <div class="mat-body-strong">
        {{issue.closedBy?.name}} closed on {{issue.closed_at | dateFormat: 'MMMM DD'}}
      </div>
    }
    <div class="tags">
      <span class="tag">{{issueTypeLabel(issue.type)}}</span>
      <!-- One status pill: the plain open / closed tag, or the contractor-workflow stage -->
      @if (status && !isStageStatus) {
        <span class="tag">
          @switch (issue.status) {
            @case ('open') {
              Open
            }
            @case ('closed') {
              Closed
            }
          }
        </span>
      }
      @if (status) {
        <app-issue-stage-chip [compact]="true" [issue]="issue" />
      }
      @if (internal) {
        <span class="tag">
          @switch (issue.internal) {
            @case (true) {
              Private
            }
            @case (false) {
              Public
            }
          }
        </span>
      }
    </div>
  </section>
}
